import { Action, createReducer, on } from "@ngrx/store";

import { PaginationRequest } from "src/app/models/common/paginationRequest";
import { ColumnSorterInfo } from "src/app/models/custom-table/custom-table.model";
import { CardActionDTO } from "src/app/models/pos-cards/posCardsDTO";

import * as PosCardsActions from "src/app/store/actions/pos-cards/pos-cards.actions";

export interface PosCardsState {
  posCard: CardActionDTO;
  posCardList: CardActionDTO[];
  posCardExcelList: CardActionDTO[];
  posCardTransaction: any;
  isLoading: boolean;
  posCardTableConfig: ColumnSorterInfo[];
  error: Error;
  pageReq: PaginationRequest;
  totalCards?: number;
}

export const initialState: PosCardsState = {
  posCard: null,
  posCardExcelList: null,
  posCardTransaction: null,
  posCardList: null,
  posCardTableConfig: null,
  totalCards: null,
  error: null,
  isLoading: false,
  pageReq: null,
};

const posCardsReducer = createReducer(
  initialState,
  on(
    PosCardsActions.getPosCards,
    (state, { options }) =>
      ({
        ...state,
        error: null,
        options: options,
        isLoading: true,
      } as PosCardsState)
  ),
  on(PosCardsActions.loadPosCards, (state, { response }) => {
    return {
      ...state,
      posCardList: (response as any)?.result?.items
        ? (response as any)?.result?.items
        : undefined,
      error: null,
      isLoading: false,
      totalCards: (response as any)?.result?.size
        ? (response as any)?.result?.size
        : 0,
    };
  }),
  on(
    PosCardsActions.getExcelPosCards,
    (state, { options }) =>
      ({
        ...state,
        error: null,
        options: options,
        isLoading: true,
      } as PosCardsState)
  ),
  on(PosCardsActions.loadExcelPosCards, (state, { response }) => {
    return {
      ...state,
      posCardExcelList: (response as any)?.result?.items
        ? (response as any)?.result?.items
        : undefined,
      error: null,
      isLoading: false,
    };
  }),
  on(
    PosCardsActions.getPosCard,
    (state, { code }) =>
      ({
        ...state,
        error: null,
        action: code,
        isLoading: true,
      } as PosCardsState)
  ),
  on(PosCardsActions.loadPosCard, (state, { response }) => {
    return {
      ...state,
      posCard: (response as any).result ? (response as any).result : undefined,
      error: null,
      isLoading: false,
    };
  }),
  on(PosCardsActions.setLoadingEndState, (state) => {
    return {
      ...state,
      isLoading: false,
      error: null,
    };
  }),
  on(PosCardsActions.getPosCardsTableConfig, (state) => {
    return {
      ...state,
      isLoading: true,
    };
  }),
  on(PosCardsActions.loadPosCardsTableConfig, (state, { response }) => {
    return {
      ...state,
      posCardTableConfig:
        (response as any)?.result?.value?.tableColumnInfo ?? undefined,
    };
  }),
  on(PosCardsActions.savePosCardsTableConfig, (state) => {
    return {
      ...state,
      isLoading: true,
    };
  }),
  on(PosCardsActions.resetPosCardsState, () => initialState),
  on(PosCardsActions.resetPosCard, (state) => {
    return {
      ...state,
      posCard: null,
      error: null,
    };
  })
);
export function reducer(state: PosCardsState | undefined, action: Action) {
  return posCardsReducer(state, action);
}
